import { render, staticRenderFns } from "./FrameInfoPane.vue?vue&type=template&id=5c41fc03&scoped=true&"
import script from "./FrameInfoPane.vue?vue&type=script&lang=js&"
export * from "./FrameInfoPane.vue?vue&type=script&lang=js&"
import style0 from "./FrameInfoPane.vue?vue&type=style&index=0&id=5c41fc03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41fc03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
